import { takeLatest } from 'redux-saga/effects'
import { MemosActions } from '../../slices/memoSlice'
import { handleFinalMemoSaga } from './handleFinalMemoSaga'

export default [takeLatest(MemosActions.appendFinalMemo, handleFinalMemoSaga)]
